import React from 'react';
import PropTypes from 'prop-types';
import SearchRow from '../../components/SearchRow';
import QuickLinks from '../../components/QuickLinks';

const SearchPage = ({ deviceInfo = {}, ...props }) => {
  const {
    toolTileProps: {
      app: { context: { user: { isLoggedIn } = {} } = {} } = {}
    } = {},
    experimentation: { moduleFederation } = {},
    quicklinks
  } = props;
  return (
    <div id="appcenter-main">
      <div id="appcenter-categories">
        <SearchRow {...props} />
      </div>
      {deviceInfo.isDesktop && (
        <QuickLinks
          moduleFederation={moduleFederation}
          isLoggedIn={isLoggedIn}
          isDesktop={deviceInfo.isDesktop}
          quicklinks={quicklinks}
        />
      )}
    </div>
  );
};

SearchPage.displayName = 'search';

SearchPage.propTypes = {
  fptiClick: PropTypes.func,
  appSearch: PropTypes.object,
  flatPSData: PropTypes.object,
  toolTileProps: PropTypes.object,
  deviceInfo: PropTypes.object,
  experimentation: PropTypes.object,
  quicklinks: PropTypes.object
};

export default SearchPage;
